import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenesysEmailWidgetComponent } from './genesys-email-widget.component';
import { GenesysEmailWidgetHeaderComponent } from './genesys-email-widget-header/genesys-email-widget-header.component';
import { SvgAvatarModule } from 'shared/components/svg-avatar';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { GenesysWidgetHeaderToolsModule } from 'shared/components/genesys-widget-header-tools';
import { TranslateModule } from '@ngx-translate/core';
import { GenesysEmailBoxModule } from './genesys-email-box/genesys-email-box.module';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { GenesysIntegrationPanelModule } from 'shared/components/genesys-integration-panel/genesys-integration-panel.module';
import { GenesysTransferPanelModule } from 'shared/components/genesys-transfer-panel/genesys-transfer-panel.module';

@NgModule({
  imports: [
    CommonModule,
    SvgAvatarModule,
    SvgIconModule,
    TranslateModule,
    GenesysEmailBoxModule,
    LoadingModule,
    GenesysWidgetHeaderToolsModule,
    GenesysIntegrationPanelModule,
    GenesysTransferPanelModule
  ],
  declarations: [
    GenesysEmailWidgetComponent,
    GenesysEmailWidgetHeaderComponent
  ],
  exports: [
    GenesysEmailWidgetComponent
  ]
})
export class GenesysEmailWidgetModule {}
